import { useCallback, useState } from 'react';

import Modal from '@perpay-web/components/base/Modal/Modal';
import PayrollInstructionsFlowContainer from '@perpay-web/fintech/components/containers/PayrollInstructionsFlowContainer';

import styles from './PayrollInstructionsModal.scss';

const PayrollInstructionsModal = ({
    customAmount = '',
    onClose,
    instructionsType = null,
    onClickFinished: ownPropsOnClickFinished,
    closeWhenSupportToolLaunched = true,
    skipLanding = false,
}) => {
    const [isShowModalClose, setIsShowModalClose] = useState(true);

    const onClickFinished = useCallback(() => {
        onClose(instructionsType);
        ownPropsOnClickFinished();
    }, [instructionsType, onClose, ownPropsOnClickFinished]);

    const onClickNeedHelpFromModal = useCallback(
        () => setIsShowModalClose(false),
        [],
    );

    const onClickBackFromModal = useCallback(
        () => setIsShowModalClose(true),
        [],
    );

    return (
        <Modal
            fullscreen
            onClose={onClose}
            showClose={isShowModalClose}
            lock={false}
        >
            <div className={styles['instructions-container']}>
                <PayrollInstructionsFlowContainer
                    onClickFinished={onClickFinished}
                    instructionsType={instructionsType}
                    closeWhenSupportToolLaunched={closeWhenSupportToolLaunched}
                    skipLanding={skipLanding}
                    onClickNeedHelpFromModal={onClickNeedHelpFromModal}
                    onClickBackFromModal={onClickBackFromModal}
                    inModal
                    customAmount={customAmount}
                />
            </div>
        </Modal>
    );
};

export default PayrollInstructionsModal;
